export default "__VITE_ASSET__BhNwKxfE__"